/******************************************
*  Author : Riccardo Di Dato
*  Created On : Thu Apr 28 2022
*  File : index.ts
*******************************************/
import { isString } from '../TypeChecking/index.js';
import { hasOwnProperty } from '../Utils/index.js';
import { isAction } from "./shared.js";
/**
 * Mixin per implementare semplicemente {@link EventHandler}.
 * @author Riccardo Di Dato
 */
export function EventHandlerMixin(Base) {
    return class Scaling extends Base {
        // Dato che i mixin non permettono private e protected usiamo il doppio underscore e nomi che rendano improbabili le collisioni
        /**
         * @internal
         */
        __ehand_listeners = {};
        /**
         * @internal
         */
        __addAction(event, action) {
            if (!hasOwnProperty(this.__ehand_listeners, event)) {
                this.__ehand_listeners[event] = [];
            }
            this.__ehand_listeners[event].push(action);
        }
        /**
         * @internal
         */
        __removeAction(event, action) {
            if (hasOwnProperty(this.__ehand_listeners, event)) {
                this.__ehand_listeners[event] = this.__ehand_listeners[event].filter(e => e !== action);
            }
        }
        on(eventName, callback) {
            this.__addAction(eventName, callback);
        }
        off(evtOrAct, callback) {
            if (callback && isString(evtOrAct)) {
                this.__removeAction(evtOrAct, callback);
            }
            else if (isAction(evtOrAct)) {
                Object.keys(this.__ehand_listeners).forEach(k => {
                    this.__removeAction(k, evtOrAct);
                });
            }
        }
        trigger(eventName, data) {
            if (hasOwnProperty(this.__ehand_listeners, eventName)) {
                this.__ehand_listeners[eventName].forEach((cb) => {
                    cb(eventName, data);
                });
            }
        }
        one(eventName, callback) {
            const finalFunction = (name, data) => {
                this.off(eventName, finalFunction);
                callback(eventName, data);
            };
            this.on(eventName, finalFunction);
        }
    };
}
